import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, FlexBox, Text } from '@dixa/lib-shared-habla';
import { useCallback, useMemo, useState } from 'react';
import { tagsApi } from 'apis/tags';
import { CategorizedList, } from 'components/categorizedList';
import { useCategorizedList } from 'utils/useCategorizedList';
import { useCurrentUser } from 'utils/user/useCurrentUser';
import { TagCreateItemContent } from './components/tagCreateItemContent/tagCreateItemContent';
import { TagItemContent } from './components/tagItemContent/tagItemContent';
/** Represents the categorized tags list. */
export const CategorizedTagsList = ({ selectedTags, isActive, onChange, }) => {
    const { currentRole: { atLeastSystemadmin }, } = useCurrentUser();
    const [tagState, setTagState] = useState('active');
    const tagCategoriesResult = tagsApi.useReadTagCategoriesQuery();
    const { categories, favorites, hasNextPage, asyncStatus, arg, changeArg, search, nextPage, refetch, } = useCategorizedList({
        identityFn: (tag) => tag.id,
        apis: {
            categorized: {
                result: tagCategoriesResult,
                searchOptions: { keys: ['name'], threshold: 0.4 },
                changeArgItemPredicate: (tag, arg) => typeof arg.state === 'undefined' ||
                    (arg.state === 'active' && !tag.is_deactivated) ||
                    (arg.state === 'inactive' && tag.is_deactivated),
            },
            paginated: {
                endpoint: tagsApi.endpoints.readTags,
                initialArg: { state: tagState },
                itemsSelector: (response) => response.data.tags,
            },
        },
    });
    const handleTagStateChange = useCallback(() => {
        const state = !tagState ? 'active' : undefined;
        setTagState(state);
        changeArg({ state, limit: undefined, offset: undefined });
    }, [changeArg, tagState]);
    const showCreate = useMemo(() => {
        const searchTerm = arg === null || arg === void 0 ? void 0 : arg.searchTerm;
        return (atLeastSystemadmin &&
            asyncStatus === 'fulfilled' &&
            typeof searchTerm !== 'undefined' &&
            searchTerm.trim().length > 1 &&
            categories.every((category) => category.items.every((tag) => tag.name.toLocaleLowerCase() !== searchTerm.trim().toLowerCase())));
    }, [arg === null || arg === void 0 ? void 0 : arg.searchTerm, atLeastSystemadmin, asyncStatus, categories]);
    return (_jsx(CategorizedList, { categories: categories, selectedItems: selectedTags, asyncStatus: asyncStatus, hasNextPage: hasNextPage, showSearch: true, isMultiple: true, resetSearchOnInactive: true, isActive: isActive, isItemDisabled: (tag) => tag.is_deactivated && !selectedTags.some(({ id }) => id === tag.id), isItemFavorite: (tag) => favorites.has(tag.id), identityFn: (tag) => tag.id, categoriesTopSlot: _jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "200", padding: "200 300", as: "label" }, { children: [_jsx(Checkbox, { name: "active", checked: !tagState, onChange: handleTagStateChange }), _jsx(Text.Paragraph, Object.assign({ variant: "3" }, { children: "Include deactivated tags" }))] })), ItemContent: TagItemContent, CreateItemContent: showCreate ? TagCreateItemContent : undefined, nextPage: nextPage, refetch: refetch, search: search, onChange: onChange }));
};
